import { gql } from '@apollo/client';

type Office = {
  id: string;
  name: string;
};

type Employee = {
  id: number;
  office: Office;
};

export type QueryResult = {
  request: {
    id: string;
    employee: Employee;
  };
};

export const EMPLOYEE_OFFICE = gql`
  query employeeOffice {
    request {
      id
      employee {
        id
        office {
          id
          name
        }
      }
    }
  }
`;
